'use client';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';

import React, { useState, useRef, useEffect } from 'react';
import CouponTicket from './CouponTicket';

export default function AvailableCoupons({ coupons }) {
  const [showCoupns, setShowCoupons] = useState(false);
  const handleSHowCoupons = () => {
    setShowCoupons(!showCoupns);
  };

  const couponSwapRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      couponSwapRef.current &&
      !couponSwapRef.current.contains(event.target)
    ) {
      setShowCoupons(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="discountCoupon flex items-center relative">
      <div className="md:text-sm text-xs text-gray-400  whitespace-nowrap py-3.5 ">
        کوپن تخفیف
      </div>
      <div
        className="md:text-sm text-xs text-drak-gray pr-4 "
        ref={couponSwapRef}
      >
        <div
          className="couponCard relative rounded-md bg-chablis inline-block"
          onClick={handleSHowCoupons}
        >
          <div className="couponContent text-sm font-bold items-center text-Outrageous-Orange px-4 py-2 cursor-pointer flex">
            <span className="pl-2">انتخاب کد تخفیف</span>
            <SmallArrowDown fill="#FF5C39" />
          </div>

          <div className="circle1"></div>
          <div className="circle2"></div>
        </div>

        <div
          className={`w-[328px] bg-white p-4 shadow-[0_4px_30px_0_#6f8daa1f] rounded-md absolute z-10 top-12 ${
            showCoupns ? '' : 'hidden'
          } `}
        >
          {coupons.map((coupon) => (
            <CouponTicket coupon={coupon} key={coupon.id} />
          ))}
        </div>
      </div>
    </div>
  );
}
